import React from 'react';
import './TwoStep.css'; // Using same CSS
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const TwoStep = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate(-1);

const steps = [
  {
    moves: `<b><big>Attack</big></b><br>
            <b>Right foot back</b><br>
            <b>i. </b>Right <span class="blue">Walking Stance</span>, right obverse middle punch.<br>
            <b>ii. </b>Left front kick landing in left <span class="blue">Walking Stance</span>.`,
    defend: `<b><big>Defence</big></b><br>
             <b>i. </b>Left <span class="blue">Walking Stance</span>, left inner forearm middle block.<br>
             <b>ii. </b>Right <span class="blue">Walking Stance</span>, low section X-fist pressing block.<br><br>
             <b>Counter Attack</b><br>
             Maintaining a right <span class="blue">Walking Stance</span>, twin fist vertical punch to cheek bones.<br><br>
             <b>Finishing Move</b><br>
             Pivot anti-clockwise on the ball of the left foot, sliding back into a right <span class="blue">L-Stance</span> while performing an outer forearm guarding block.`
  },
  {
    moves: `<b><big>Attack</big></b><br>
            <b>Right foot forward</b><br>
            <b>i. </b>Right <span class="blue">Fixed Stance</span>, right side reverse middle punch.<br>
            <b>ii. </b>Left turning kick, landing in right <span class="blue">L-Stance</span>.`,
    defend: `<b><big>Defence</big></b><br>
             <b>i. </b>Right <span class="blue">L-Stance</span>, left palm inwards middle block.<br>
             <b>ii. </b>Left <span class="blue">L-Stance</span>, outer forearm waist block.<br><br>
             <b>Counter Attack</b><br>
             Slide forwards into right <span class="blue">L-Stance</span>, side-elbow thrust to solar plexus.<br><br>
             <b>Finishing Move</b><br>
             Pivot anti-clockwise on the ball of the left foot, sliding back into a right <span class="blue">L-Stance</span> while performing an outer forearm guarding block.`
  },
  {
    moves: `<b><big>Attack</big></b><br>
            <b>Right foot forward</b><br>
            <b>i. </b>Right front kick landing into right <span class="blue">Walking Stance</span>.<br>
            <b>ii. </b>Left <span class="blue">Walking Stance</span>, twin fist vertical punch.`,
    defend: `<b><big>Defence</big></b><br>
             <b>i. </b>Right <span class="blue">Walking Stance</span>, low section pressing X-fist block.<br>
             <b>ii. </b>Left <span class="blue">Walking Stance</span>, outer forearm wedging block.<br><br>
             <b>Counter Attack</b><br>
             Grab the back of the opponent's head and pull the body down into a right upward kick with the knee to the solar plexus.<br><br>
             <b>Finishing Move</b><br>
             Place the right foot beside the left and slide the left foot back to form a left <span class="blue">L-Stance</span> while performing an outer forearm guarding block.`
  },
  {
    moves: `<b><big>Attack</big></b><br>
            <b>Right foot forward</b><br>
            <b>i. </b>Right <span class="blue">Walking Stance</span>, high section right flat fingertip thrust.<br>
            <b>ii. </b>Left middle side kick landing in <span class="blue">Sitting Stance</span>.`,
    defend: `<b><big>Defence</big></b><br>
             <b>i. </b>Left <span class="blue">Walking Stance</span>, left knife-hand rising block.<br>
             <b>ii. </b>Left <span class="blue">L-Stance</span>, right palm heel middle block.<br><br>
             <b>Counter Attack</b><br>
             Left front snap kick to the base of the spine landing into left <span class="blue">Walking Stance</span> and twin fist upset punch to the kidneys.<br><br>
             <b>Finishing Move</b><br>
             Place the left foot beside the right and slide the right foot back to form a right <span class="blue">L-Stance</span> while performing an outer forearm guarding block.`
  },
  {
    moves: `<b><big>Attack</big></b><br>
            <b>Right foot forward</b><br>
            <b>i. </b>Right middle front snap kick landing into right <span class="blue">Walking Stance</span>.<br>
            <b>ii. </b>Left <span class="blue">Walking Stance</span>, middle obverse punch.`,
    defend: `<b><big>Defence</big></b><br>
             <b>i. </b>Right <span class="blue">Walking Stance</span>, X-fist pressing block.<br>
             <b>ii. </b>Pivot on left foot to a 45-degree angle into a right <span class="blue">L-Stance</span> and outer forearm guarding block.<br><br>
             <b>Counter Attack</b><br>
             Right turning kick to the solar plexus landing into a left <span class="blue">L-Stance</span> and obverse backfist strike to the temple.<br><br>
             <b>Finishing Move</b><br>
             Pivot anti-clockwise on the ball of the left foot, sliding back into a right <span class="blue">L-Stance</span> while performing an outer forearm guarding block.`
  },
  {
    moves: `<b><big>Attack</big></b><br>
            <b>Right foot forward</b><br>
            <b>i. </b>Right <span class="blue">Fixed Stance</span>, right side middle punch.<br>
            <b>ii. </b>Left foot to right foot, right front reverse turning kick.`,
    defend: `<b><big>Defence</big></b><br>
             <b>i. </b>Right <span class="blue">L-Stance</span>, left palm heel middle block.<br>
             <b>ii. </b>Left <span class="blue">L-Stance</span>, right outer forearm high block.<br><br>
             <b>Counter Attack</b><br>
             Jumping up while performing a right knife-hand strike to the back of the neck.<br><br>
             <b>Finishing Move</b><br>
             After landing, skip back into a left <span class="blue">L-Stance</span> while performing an outer forearm guarding block.`
  },
  {
    moves: `<b><big>Attack</big></b><br>
            <b>Left foot forward</b><br>
            <b>i. </b>Left <span class="blue">L-Stance</span>, right knife-hand strike.<br>
            <b>ii. </b>Pivot on the right foot, spinning around executing a reverse side piercing kick.`,
    defend: `<b><big>Defence</big></b><br>
             <b>i. </b>Left <span class="blue">L-Stance</span>, right knife-hand middle block.<br>
             <b>ii. </b>Right <span class="blue">L-Stance</span>, left knife-hand low block.<br><br>
             <b>Counter Attack</b><br>
             Jumping up while performing a left knife-hand strike to the back of the neck.<br><br>
             <b>Finishing Move</b><br>
             After landing, skip back into a right <span class="blue">L-Stance</span> while performing an outer forearm guarding block.`
  }
];

return (
  <>
    <Helmet>
      <title>TKD Study - 2 Step</title>
    </Helmet>
    <div className="three-step-container">
      <h1 className="three-step-title">Two Step</h1>
      <button className="back-button" onClick={handleBack}>← Back</button>
      <div className="three-step-content">
        <p>
          <b>What is Two Step?</b><br />
          The main purpose of Two step <span className="green"><b>(Ibo Matsogi)</b></span> is to acquire a mixed technique of hand and foot parts. The attacker therefore must use both hands and feet alternatively.
        </p>

        <p>
          <b><big>Attacking</big></b><br />
          The attack in 2 step always starts from a right <span className="blue"><b>L-Stance</b></span> while executing a middle forearm guarding block.<br />
          Throughout the 7 routines, the attack techniques differ.
        </p>

        <p>
          <b><big>Defending</big></b><br />
          The defence in 2 step always starts from <span className="blue"><b>Parallel Ready Stance</b></span>.<br />
          Throughout the 7 routines, the defence techniques differ.<br />
          Each defence ends with a <b>Counter-Attack</b> and <b>Finishing Move</b>.
        </p>
        {steps.map((step, index) => (
          <div className="three-step-section" key={index}>
            <h2 className="step-title">No. {index + 1}</h2>
            <div className="step-moves">
              <div dangerouslySetInnerHTML={{ __html: step.moves }} />
              <div dangerouslySetInnerHTML={{ __html: step.defend }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </>
);

};

export default TwoStep;
